<template>
  <div v-if="usuario">
    <v-card>
      <v-toolbar card>
        <v-icon>person</v-icon>
        <v-toolbar-title class="font-weight-light"
          >Perfil de Usuario</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn
          v-if="level > 6"
          @click="adminDialog = !adminDialog"
          class="error"
          >Admin</v-btn
        >
      </v-toolbar>
      <v-card-text>
        <v-container fluid grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm5 md2>
              <v-text-field
                @input="forceUppercase($event, usuario.private, 'nombre')"
                label="Nombre"
                v-model="usuario.private.nombre"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm5 md2>
              <v-text-field
                @input="forceUppercase($event, usuario.private, 'apellido1')"
                label="Apellido1"
                v-model="usuario.private.apellido1"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm5 md2>
              <v-text-field
                @input="forceUppercase($event, usuario.private, 'apellido2')"
                label="Apellido2"
                v-model="usuario.private.apellido2"
              >
              </v-text-field>
            </v-flex>

            <v-flex xs12 sm5 md2>
              <v-autocomplete
                v-model="usuario.private.direccion.provincia"
                :items="provinciaSelect"
                :filter="customFilter"
                item-text="text"
                label="Provincia"
                @change="changeProvincia"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm12 md3>
              <v-autocomplete
                v-model="usuario.private.direccion.localidad"
                :items="municipioSelect"
                :filter="customFilter"
                item-text="text"
                label="Localidad"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm3 md1>
              <v-text-field
                label="C.P."
                v-model="usuario.private.direccion.cp"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4>
              <v-text-field
                @input="
                  forceUppercase($event, usuario.private.direccion, 'calle')
                "
                label="Dirección"
                v-model="usuario.private.direccion.calle"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm4 md1>
              <v-text-field
                @input="forceUppercase($event, usuario.private, 'nif')"
                label="NIF"
                v-model="usuario.private.nif"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm4 md2>
              <v-text-field
                :disabled="seguroEmail"
                label="email"
                v-model="usuario.admin.email"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 md1>
              <v-text-field
                :disabled="seguroMovil"
                label="Móvil Principal"
                v-model="usuario.private.tlf1"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4>
              <v-combobox
                v-model="usuario.private.tlf"
                :items="phoneItems"
                :search-input.sync="phoneSearch"
                hide-selected
                hint="Escribe un número de teléfono y presiona ENTER para introducirlo"
                label="Otros Teléfonos"
                multiple
                persistent-hint
                deletable-chips
                small-chips
              >
              </v-combobox>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-card color="grey lighten-4" height="20vh">
                <v-container fluid class="px-2">
                  <v-layout row wrap>
                    <v-flex xs12>
                      Fecha de Nacimiento:
                    </v-flex>

                    <v-flex xs3>
                      <!-- <v-text-field label="Dia" ></v-text-field> -->
                      <v-autocomplete
                        v-model="usuario.private.fechaNacimientoDia"
                        :items="fechaNac.dias"
                        label="Dia"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs3>
                      <!-- <v-text-field label="Mes" ></v-text-field> -->
                      <v-autocomplete
                        v-model="usuario.private.fechaNacimientoMes"
                        :items="fechaNac.meses"
                        label="Mes "
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6>
                      <!-- <v-text-field label="Año" ></v-text-field> -->
                      <v-autocomplete
                        v-model="usuario.private.fechaNacimientoYear"
                        :items="fechaNac.years"
                        label="Año"
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-card color="blue lighten-5" height="20vh">
                <v-container fluid class="px-2">
                  <v-textarea
                    name="notas-txt"
                    height="9vh"
                    label="Notas"
                    v-model="usuario.private.notas"
                  ></v-textarea>
                </v-container>
              </v-card>
            </v-flex>
            <v-flex xs12 sm4 md3 v-if="inmueblesUser.length > 0">
              <v-card color="white">
                <v-card-title>
                  Inmuebles
                </v-card-title>
                <!-- <v-container fluid class="px-2"> -->
                <v-list subheader dense>
                  <!-- <v-subheader inset>Inmuebles</v-subheader> -->

                  <v-list-tile
                    v-for="item in inmueblesUser"
                    :key="item.idx"
                    @click="abrirInmuebleUser(item.idx)"
                    avatar
                  >
                    <v-list-tile-avatar>
                      <v-icon class="blue white--text">assignment</v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.idx }}</v-list-tile-title>
                      <!-- <v-list-tile-sub-title>{{ item.data.idInmueble }}</v-list-tile-sub-title> -->
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <v-btn icon ripple>
                        <v-icon color="grey lighten-1">info</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
                <!-- </v-container> -->
              </v-card>
            </v-flex>
            <!-- discapacidad -->
            <v-flex xs12 sm6 md3>
              <v-card>
                <v-container fluid class="px-2">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-checkbox
                        label="¿Tiene alguna Discapacidad?"
                        v-model="discapacidad.isDiscapacidad"
                      >
                      </v-checkbox>
                    </v-flex>
                    <template v-if="discapacidad.isDiscapacidad">
                      <v-flex xs12>
                        <span class=""
                          ><small>{{ discapacidadString }}</small></span
                        >
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-btn
                          color="primary"
                          @click="infoDiscapacidad = !infoDiscapacidad"
                        >
                          Cambiar Tipo / Grado
                        </v-btn>
                      </v-flex>
                    </template>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="userSave">
          Guardar
        </v-btn>
        <v-btn color="danger" @click="userReset">
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Discapacidad -->
    <v-dialog v-model="infoDiscapacidad" width="500" scrollable>
      <v-card>
        <v-toolbar card dark :color="temaColor">
          <v-toolbar-title>
            Seleccione el tipo y grado de discapacidad
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="infoDiscapacidad = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card tile>
          <v-container fluid grid-list-md>
            <v-layout row justify-space-around fill-height align-center>
              <v-flex xs12>
                <v-list subheader>
                  <v-subheader class="pl-0">Tipo:</v-subheader>
                  <v-list-tile
                    class="pb-3"
                    :disabled="discapacidad.tipo === 'i'"
                    @click="discapacidadTipo('i')"
                    avatar
                  >
                    <v-list-tile-avatar>
                      <v-avatar
                        :color="discapacidad.tipo === 'i' ? 'grey' : 'blue'"
                      >
                        <span class="white--text headline">i</span>
                      </v-avatar>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>Mínimo 33%</v-list-tile-title>
                      <v-list-tile-sub-title
                        >Parálisis cerebral, enfermedad
                        mental,</v-list-tile-sub-title
                      >
                      <v-list-tile-sub-title
                        >discapacidad intelectual o discapacidad del
                        desarrollo</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider>
                  <v-list-tile
                    class="pt-3"
                    :disabled="discapacidad.tipo === 'ii'"
                    @click="discapacidadTipo('ii')"
                    avatar
                  >
                    <v-list-tile-avatar>
                      <v-avatar
                        :color="discapacidad.tipo === 'ii' ? 'grey' : 'red'"
                      >
                        <span class="white--text headline">ii</span>
                      </v-avatar>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>Mínimo 65%</v-list-tile-title>
                      <v-list-tile-sub-title
                        >Discapacidad física o sensorial</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>

        <v-divider></v-divider>

        <v-card>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12>
                <v-slider
                  label="Grado:"
                  v-model="discapacidad.grado"
                  thumb-label="always"
                >
                </v-slider>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  label="¿Tiene un documento acreditativo?"
                  v-model="discapacidad.documentoDiscapacidad"
                  value="true"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  label="¿Tiene movilidad reducida?"
                  v-model="discapacidad.movilidad"
                  value="true"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-card>
    </v-dialog>

    <!-- Opciones Admin -->
    <v-dialog
      v-if="level > 5"
      v-model="adminDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <v-toolbar card dark color="red">
          <v-btn icon dark @click.native="adminDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <v-btn flat small fab outline color="white">
              {{ usuario.admin.level }}
            </v-btn>
            Administración Usuario
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <h2>
            {{ usuario.private.nombre }} {{ usuario.private.apellido1 }}
            {{ usuario.private.apellido2 }}
          </h2>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="userSave">Guardar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <!-- <v-card>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md3><v-autocomplete v-model="usuario.admin.rol" :items="usersRols" item-text="rol" label="Rol Usuario" @change="changeRolUser"></v-autocomplete></v-flex>
                                <v-flex xs12 sm6 md3><v-text-field label="Email" v-model="usuario.admin.email"></v-text-field></v-flex>
                                
                                <v-flex xs12 sm6 md2>
                                    <v-text-field 
                                        append-icon="mdi-send"
                                        :disabled="newPassword.length < 5"
                                        color="blue"
                                        @click:append="passGenerate"
                                        label="Nuevo Password"
                                        v-model="newPassword">
                                    </v-text-field>
                                </v-flex>
                                
                                <v-flex xs12>
                                    <v-btn :disabled="!usuario.admin.email" class="primary">Invitar por email</v-btn>
                                    <v-btn :disabled="!usuario.admin.email" class="primary">Forzar Nuevo Password</v-btn>
                                    <v-btn :disabled="!usuario.admin.email" class="primary">Recordar Email</v-btn>
                                    <v-btn :disabled="!usuario.admin.email" class="primary" @click="passGenerate">Genera Password</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>

                <v-divider></v-divider> -->

        <v-card tile>
          <!-- <v-container fluid grid-list-md>
                        <v-layout row justify-space-between>
                            <v-flex xs12 sm6>
                                Hola
                            </v-flex>
                        </v-layout>
                    </v-container>

                    <v-divider></v-divider> -->

          <v-container fluid grid-list-md>
            <v-layout row justify-space-around fill-height align-center>
              <!-- Formulario Datos -->
              <v-flex xs12 sm2>
                <v-autocomplete
                  v-model="usuario.admin.rol"
                  :items="usersRols"
                  item-text="rol"
                  label="Rol Usuario"
                  @change="changeRolUser"
                ></v-autocomplete>
                <v-text-field
                  label="Email"
                  v-model="usuario.admin.email"
                ></v-text-field>
                <v-text-field
                  label="Móvil Principal"
                  v-model="usuario.private.tlf1"
                ></v-text-field>
                <v-text-field
                  append-icon="mdi-send"
                  :disabled="newPassword.length < 5"
                  color="blue"
                  @click:append="passGenerate"
                  label="Nuevo Password"
                  v-model="newPassword"
                >
                </v-text-field>
              </v-flex>

              <!-- Acciones -->
              <v-flex xs12 sm4>
                <v-list subheader>
                  <v-subheader>Acciones</v-subheader>

                  <v-list-tile
                    :disabled="
                      usuario.admin.isVerified ||
                        usuario.admin.noEnvviarEmails ||
                        !usuario.admin.email
                    "
                    @click="registroEmailUser"
                    avatar
                  >
                    <v-list-tile-avatar>
                      <v-icon
                        :class="
                          !usuario.admin.isVerified &&
                          !usuario.admin.noEnvviarEmails &&
                          usuario.admin.email
                            ? 'blue white--text'
                            : 'grey white--text'
                        "
                        >mdi-email</v-icon
                      >
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>Invitar por email</v-list-tile-title>
                      <v-list-tile-sub-title
                        >Envía un enlace de regitro al
                        usuario</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile
                    :disabled="!usuario.admin.isVerified"
                    @click="passwordRememberEmailUser"
                    avatar
                  >
                    <v-list-tile-avatar>
                      <v-icon
                        :class="
                          usuario.admin.isVerified
                            ? 'blue white--text'
                            : 'grey white--text'
                        "
                        >mdi-comment-question-outline</v-icon
                      >
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>Recordar Password</v-list-tile-title>
                      <v-list-tile-sub-title
                        >Envía un email al usuario para que renueve su
                        Password</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile
                    :disabled="!usuario.admin.isVerified"
                    @click="passGenerate"
                    avatar
                    ><v-list-tile-avatar>
                      <v-icon
                        :class="
                          usuario.admin.isVerified
                            ? 'blue white--text'
                            : 'grey white--text'
                        "
                        >mdi-key-change</v-icon
                      >
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title
                        >Generar Nuevo Password</v-list-tile-title
                      >
                      <v-list-tile-sub-title
                        >Genera un Password aleatorio que podrá ser enviado por
                        email</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile
                    :disabled="!usuario.private.tlf1"
                    @click="registroWhatsappUser"
                    avatar
                    ><v-list-tile-avatar>
                      <v-icon
                        :class="
                          usuario.private.tlf1
                            ? 'green white--text'
                            : 'grey white--text'
                        "
                        >mdi-whatsapp</v-icon
                      >
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title
                        >Invitar por Whatsapp</v-list-tile-title
                      >
                      <v-list-tile-sub-title
                        >Envía un enlace de regitro al
                        usuario</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>

              <!-- Opciones Generales -->
              <v-flex xs12 sm4>
                <v-list subheader>
                  <v-subheader>Opciones Generales</v-subheader>

                  <v-list-tile avatar>
                    <v-list-tile-action>
                      <v-checkbox
                        v-model="usuario.admin.noEnvviarEmails"
                      ></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-avatar>
                      <v-icon
                        :class="
                          usuario.admin.noEnvviarEmails
                            ? 'red white--text'
                            : 'grey white--text'
                        "
                        >send</v-icon
                      >
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title
                        >Sin Notificaciones Emails</v-list-tile-title
                      >
                      <v-list-tile-sub-title
                        >No Permite enviar Notificaciones por
                        email</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar v-if="!usuario.admin.noEnvviarEmails">
                    <v-list-tile-action>
                      <v-checkbox
                        v-model="usuario.admin.verificarEmail"
                      ></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-avatar>
                      <v-icon class="grey white--text">mdi-email</v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>Verificar Email</v-list-tile-title>
                      <v-list-tile-sub-title
                        >Envío automático de email al usuario para que valide su
                        cuenta</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile avatar>
                    <v-list-tile-action>
                      <v-checkbox
                        v-model="usuario.admin.isVerified"
                      ></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-avatar>
                      <v-icon class="grey white--text">mdi-email-open</v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>Email Verificado</v-list-tile-title>
                      <v-list-tile-sub-title>{{
                        `El usuario ${
                          usuario.admin.isVerified ? "ha" : "no ha"
                        } verificado su cuenta de correo.`
                      }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>

        <v-divider></v-divider>

        <v-card color="red lighten-5">
          <v-container grid-list-md>
            <v-layout row justify-space-around fill-height align-center>
              <v-flex xs12>
                <v-textarea
                  name="notas-admin-txt"
                  height="10vh"
                  label="Notas Admin"
                  v-model="usuario.admin.notas"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <div class="loading" v-if="guardando"></div>
  </div>
</template>

<script>
import { dbFB } from "../firebase.js";
import { completaNif } from "@/plugins/functions.js";
export default {
  name: "perfil-usuario",
  data() {
    return {
      aaa: false,
      infoDiscapacidad: false,
      discapacidad: {
        isDiscapacidad: false,
        tipo: false,
        grado: 0,
        movilidad: false,
        documentoDiscapacidad: false
      },
      inmuebles: [],
      inmuebleSearch: null,
      phoneItems: [],
      phoneSearch: null,
      // date: "2010-05-01",
      modal: false,
      adminDialog: false,
      usuario: null,
      guardando: false,
      fechaNac: {
        dias: [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31
        ],
        meses: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        years: []
      },
      seguroEmail: false,
      seguroMovil: false,
      newPassword: ""
    };
  },
  watch: {
    /* isDiscapacidad(newValue, oldValue){
            
        } */
  },
  created() {
    this.checkUsuario();
    this.autocompleteFecha();
  },
  mounted: function() {
    /* if (this.user) {
            this.usuario = this.user
            if (this.user.direccion.provincia) {
                this.changeProvincia()
            }
        } */
    /* if (this.usuario) {
            // this.usuario = this.user
            if (this.usuario.private.direccion.provincia) {
                this.changeProvincia()
            }
        } */
  },
  computed: {
    discapacidadString() {
      const discapacidad = this.discapacidad;
      return `Tipo: ${discapacidad.tipo ? discapacidad.tipo : "-"} / Grado: ${
        discapacidad.grado ? discapacidad.grado : "-"
      } / Movilidad: ${discapacidad.movilidad ? "SI" : "No"} / Documento: ${
        discapacidad.documentoDiscapacidad ? "SI" : "No"
      }`;
    },
    usuarioDiscapacidad() {
      let result = this.discapacidad;
      if (this.usuario && this.usuario.private.discapacidad) {
        result = this.usuario.private.discapacidad;
      }
      return result;
    },
    temaColor() {
      return this.$store.getters.getTemaColorAdminUI;
    },
    linkWhatsapp() {
      if (this.usuario.private.tlf1 && this.usuario.private.nombre) {
        let nombre = this.usuario.private.nombre
          .toLowerCase()
          .split(" ")
          .map(s => s.charAt(0).toUpperCase() + s.substring(1))
          .join(" ");

        // return nombre
        const result = {
          uid: this.userUid,
          nombre: nombre,
          tlf: this.usuario.private.tlf1
        };

        // return result

        const encBtoA = window.btoa(JSON.stringify(result));
        const url = "https://usuarios.gestionayudas.es/register/phone/?token=";
        const token = `${url}${encBtoA}`;

        let message = encodeURIComponent(`Hola ${nombre},
                Le escribimos desde gestionayudas.es, en virtud de acuerdo suscrito con su Comunidad de Propietarios, en relación a la tramitación de las subvenciones que estamos gestionando para usted y para su Comunidad de Propietarios.
                Para poder continuar con nuestro trabajo, necesitamos que acceda a nuestro sitio web y siga las instrucciones para realizar el proceso de alta y toma de datos.
                Por favor, haga click en el siguiente enlace para acceder:
                ${token}`);

        // return message
        // const lnk = "https://api.whatsapp.com/send?text="+message+"&phone="+encodeURIComponent(`34${tlf}`)
        const phone = encodeURIComponent(`34${this.usuario.private.tlf1}`);
        const lnk = `https://api.whatsapp.com/send?text=${message}&phone=${phone}`;
        return lnk;
      }
      return false;
    },
    inmueblesUser() {
      if (this.usuario.private.inmuebles) {
        return Object.keys(this.usuario.private.inmuebles).map(i => {
          return { data: this.usuario.private.inmuebles[i], idx: i };
        });
        // return Object.keys(this.usuario.private.inmuebles)
      }
      return [];
    },
    level() {
      return this.$store.getters.getLevel;
    },
    uid() {
      return this.$store.getters.getUserUid;
    },
    userUid() {
      return this.$route.params.id || this.uid;
    },
    usuario_old() {
      return this.$store.getters.getUsuarioSeleccionado(this.userUid); //getUserSelected(this.userUid)
    },
    municipioSelect() {
      return this.$store.getters.getMunicipiosSelect;
    },
    provinciaSelect() {
      return this.$store.getters.getProvinciasSelect;
    },
    usersRols() {
      return this.$store.getters.getRoles;
    },
    query() {
      return this.$route.query;
    },
    expedienteQuery() {
      if (this.query && this.query.refCatastral) {
        const expte =
          this.$store.getters.getCatastroId(this.query.refCatastral)
            .expediente || null;
        if (expte) {
          return this.$store.getters.getExpedienteSelected(expte);
        }
      }
      return null;
    }
  },
  methods: {
    discapacidadTipo(t) {
      this.discapacidad.tipo = t;
      if (t === "i") {
        this.discapacidad.grado = 33;
      } else {
        this.discapacidad.grado = 65;
      }
    },
    forceUppercase(e, o, prop) {
      // this.aaa = e
      if (prop === "nif" && o.nif.length === 8) {
        this.$set(o, prop, completaNif(o.nif));
        return;
      }
      //https://forum.vuejs.org/t/inputs-always-in-uppercase-using-v-model/7450/9
      e = e.toUpperCase();
      this.$set(o, prop, e);
    },
    passwordRememberEmailUser() {
      // Envía un enlace de recuperación de password
    },
    registroWhatsappUser() {
      // Envía un Whatsapp con el enlace de registro al usuario
      if (!this.linkWhatsapp) {
        return;
      }
      const item = this.usuario.private;
      const tlf = item.tlf1;
      // const nombre = item.preUserName
      let nombre = item.nombre;
      if (nombre.length < 2) {
        return alert(`El Nombre introducido no es correcto ${nombre}`);
      }
      const patronTlf = /^[6][0-9]{8}$/;
      if (!patronTlf.test(tlf)) {
        return alert(`El teléfono introducido no es correcto ${tlf}`);
      }

      window.open(this.linkWhatsapp);
    },
    registroEmailUser() {
      // Envía un email con el enlace de registro al usuario
      if (this.usuario.admin.email) {
        this.$store.dispatch("setEnviaLinkRegistroUser", this.userUid);
      }
    },
    abrirInmuebleUser(idx) {
      return idx;
    },
    mayuculas(txt) {
      return txt.toUpperCase();
    },
    autocompleteFecha() {
      const actualYear = new Date().getFullYear();
      const rango = 120;
      this.fechaNac.years = [];
      for (let index = actualYear; index > actualYear - rango; index--) {
        this.fechaNac.years.push(index);
      }
    },
    checkDireccion() {
      dbFB
        .ref("newCatastro")
        .child(this.query.refCatastral)
        .child("inmuebles")
        .child(this.query.idInmueble)
        .once("value")
        .then(snapshot => {
          // eslint-disable-next-line
          console.log(`Búsqueda: < newCatastro > < ${this.query.refCatastral} > < ${this.query.idInmueble} > : ${snapshot.val()}`);
          const data = snapshot.val();
          if (data) {
            this.usuario.private.direccion.calle = data.direccion;
          }
        });
      if (this.expedienteQuery) {
        this.usuario.private.direccion.provincia =
          this.expedienteQuery.detalle.provincia || "";
        this.usuario.private.direccion.cp =
          this.expedienteQuery.detalle.cp || "";
        if (
          this.expedienteQuery.detalle.localidad &&
          this.expedienteQuery.detalle.localidad !== "Seleccionar"
        ) {
          this.usuario.private.direccion.localidad = this.expedienteQuery.detalle.localidad;
        }
      }
    },
    checkUsuario() {
      this.usuario = this.$store.getters.getUsuarioSeleccionado(this.userUid);
      if (!this.usuario) {
        return;
      }
      if (this.usuario.private.discapacidad) {
        this.discapacidad = Object.assign(
          {},
          this.usuario.private.discapacidad
        );
      }
      if (this.usuario.admin.email && this.usuario.admin.email !== "") {
        this.seguroEmail = true;
      }
      if (this.usuario.private.tlf1 && this.usuario.private.tlf1 !== "") {
        this.seguroMovil = true;
      }
      if (this.query && this.query.inmuebleUser) {
        this.usuario.private.inmuebles = {
          [this.query.inmuebleUser]: {
            refCatastral: this.query.refCatastral,
            idInmueble: this.query.idInmueble
          }
        };
        this.checkDireccion();
      }
      if (this.usuario) {
        // this.usuario = this.user
        if (this.usuario.private.direccion.provincia !== "") {
          this.changeProvincia();
        }
      }
      this.guardando = false;
      // filter=Usuario
      // refCatastral=8874705YH1487D
      // idInmueble=0002
      // inmuebleUser=8874705YH1487D0002SS

      /* const payload = {
                refCatastral: this.query.refCatastral,
                idInmueble: this.query.idInmueble,
                inmuebleUser: this.query.inmuebleUser,
                idUser: idx
            }
            this.$store.dispatch('addUserInmueble', payload)
            this.$router.back() */
    },
    passGenerate() {
      const longitud = 12;
      const caracteres =
        "abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ2346789";
      let passGen = "";
      for (let i = 0; i < longitud; i++)
        passGen += caracteres.charAt(
          Math.floor(Math.random() * caracteres.length)
        );
      this.newPassword = passGen;
      // return passGen
    },
    userSave() {
      // Error: Reference.set failed: First argument contains undefined in property 'users.NUI0YzFUOS0xNTQxNDkyMjg3MzQ2.private.direccion.cp'
      // NUIwbDQ2OS0xNTQxNDkyOTc0NDA5
      // MWg0YzhoOS0xNTQxNDk0MDY4MTUx

      const userUid = this.userUid || false;
      if (!userUid) {
        return;
      }
      this.usuario.private.discapacidad = this.discapacidad;
      let user = {
        data: this.usuario, // JSON.parse(JSON.stringify(this.usuario)),
        uid: userUid
      };
      /* let newUserInmueble = false
            if (this.quey && this.query.inmuebleUser) {
                newUserInmueble = true

            } */
      this.guardando = true;
      this.$store.dispatch("updateUser", user);

      if (this.query && this.query.inmuebleUser) {
        const payload = {
          omiteHuellaUser: true,
          refCatastral: this.query.refCatastral,
          idInmueble: this.query.idInmueble,
          inmuebleUser: this.query.inmuebleUser,
          idUser: this.userUid
        };
        this.$store.dispatch("addUserInmueble", payload);
        this.$router.go(-2);
        this.guardando = false;
      } else {
        this.guardando = false;
      }
    },
    userReset() {},
    customFilter(item, queryText) {
      const textOne = item.text.toLowerCase();
      const searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1;
    },
    changeProvincia() {
      this.$store.dispatch(
        "setMunicipios",
        this.usuario.private.direccion.provincia
      );
    },
    changeRolUser() {
      this.usuario.admin.level = this.usersRols.filter(
        item => item.rol === this.usuario.admin.rol
      )[0].level;
    }
  }
};
</script>

<style scoped>
.loading {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: url(../../assets/pageloader_04.gif) 50% 50% no-repeat
    rgb(249, 249, 249);
  opacity: 0.8;
}
input {
  color: dimgray;
}

/* > div > div.v-input__slot > div > input[type="text"] */
.upper-text > div > div.v-input__slot > div > input {
  text-transform: uppercase;
}
</style>
